import "./chunk-EUXUH3YW.js";

// libs/widgets/src/lib/token-icon/repositories/trustwallet.repository.ts
import { ChainId } from "@one-inch-community/models";
import { getAddress } from "viem/utils";
var chainName = {
  [ChainId.eth]: "ethereum",
  [ChainId.bnb]: "binance",
  [ChainId.matic]: "polygon",
  [ChainId.op]: "optimism",
  [ChainId.arbitrum]: "arbitrum",
  [ChainId.gnosis]: "",
  [ChainId.avalanche]: "avalanchec",
  [ChainId.fantom]: "fantom",
  [ChainId.aurora]: "aurora",
  [ChainId.klaytn]: "",
  [ChainId.zkSyncEra]: "zksync"
};
var trustWalletRepository = ({ address, chainId }) => {
  return new Promise((resolve, reject) => {
    if (!address || !chainId || chainName[chainId] === "") return reject();
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = `https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/${chainName[chainId]}/assets/${getAddress(address.toLowerCase())}/logo.png`;
  });
};
export {
  trustWalletRepository
};
//# sourceMappingURL=trustwallet.repository-P6G45YEI.js.map
